module.exports = __webpack_public_path__ + "img/Weapon_205.4dd2b274.png";